import React from 'react';
import { Tooltip, Typography, TypographyTypeMap } from '@mui/material';
import { useTranslation } from "react-i18next";
import { i18n } from 'i18next';

export function ISODateTimeString(i18n: i18n, isoDateString: string, format?: object, useUTC?: boolean): string {
  const defaultFormat: any = { year: 'numeric', month: 'long', day: 'numeric' , hour: 'numeric', minute: 'numeric'}
  if (useUTC) {
    defaultFormat.timeZone = "UTC"
  }
  return i18n.t('intlDateTime',
    {
      val: new Date(isoDateString),
      formatParams: {
        val: format || defaultFormat,
      },
    });
}

export function ISODateString(i18n: i18n, isoDateString: string, format?: object, useUTC?: boolean): string {
  const defaultFormat: any = { year: 'numeric', month: 'long', day: 'numeric' };
  if (useUTC) {
    defaultFormat.timeZone = "UTC"
  }
  return i18n.t('intlDateTime',
    {
      val: new Date(isoDateString),
      formatParams: {
        val: format || defaultFormat,
      },
    });
}

export type DateTimeProps = {
  isoString: string;

  hideTime?: boolean;
  hideTooltip?: boolean;

  typographyVariant?: TypographyTypeMap | string;
  typographyComponent?: string;

  format?: object;
  useUTC?: boolean;

  sx?: object;
};

export default function ISODateTime(props: DateTimeProps): JSX.Element {
  const { i18n } = useTranslation();

  const variant:any = props.typographyVariant || "body1",
      typographyComponent:any = props.typographyComponent || "span";

  const isTimeEmpty = props.isoString?.includes("T00:00:00");

  let outputString = "";
  if (!props.isoString) {
    // Leave empty
  } else if (props.isoString.toLowerCase() === "now") {
    outputString = i18n.t("now");
  } else if(props.hideTime || isTimeEmpty) {
    outputString = ISODateString(i18n, props.isoString, props.format, props.useUTC);
  } else {
    outputString = ISODateTimeString(i18n, props.isoString, props.format, props.useUTC);
  }

  return (
    <Tooltip followCursor title={props.hideTooltip ? "" : props.isoString}>
      <Typography variant={variant} component={typographyComponent} sx={props.sx}>
        {outputString}
      </Typography>
    </Tooltip>
  );
}